import React from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import EmbeddedSophosApp from "./EmbeddedSophosApp";
const SophosApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("sophos.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("sophos.app.description"))), /* @__PURE__ */ React.createElement(EmbeddedSophosApp, null));
};
export default SophosApp;
